import React, {FC} from 'react'

import cn from 'classnames/bind'

import {Col, Row} from 'components/elements/grid'

import s from './ContactContent.module.scss'
import ContactForm from '../ContactForm'

const cx = cn.bind(s)

interface IContactContentProps {
	className?: string
}

const ContactContent: FC<IContactContentProps> = () => {
	return (
		<div className={cx('contact')}>
			<div className={cx('info')}>
				<h2 className={cx('title')}>Head office</h2>
				<div className={cx('text')}>
					<address className={cx('address')}>
						<strong>Form Source LLC 1875 Century Park E Los Angeles, CA 90067</strong>
					</address>
					<p className={cx('phone')}>
						<a className={cx('phone__link')} href="tel:855-607-1274">
							<strong>Phone: +1 (855) 607-1274</strong>
						</a>
					</p>
					<p className={cx('email')}>
						<strong>Email: support@paystub.org</strong>
					</p>
				</div>
			</div>
			<div className={cx('form')}>
				<Row>
					<Col md={{offset: 0, span: 12}}>
						<ContactForm />
					</Col>
				</Row>
			</div>
		</div>
	)
}

ContactContent.displayName = 'ContactContent'

export default ContactContent
